import Router from '@/Router';
import Store from '@/Store';
import { NavigationGuardNext, Route } from 'vue-router';

/**
 * Description of middleware
 *
 * @return void
 */
export function Onboarding(to: Route, from: Route, next: NavigationGuardNext): void {
	if (Store.getters['settings/onboardingComplete']) {
		// If onboarding is complete, continue to the next route
		return next();
	}

	// Avoid foreve rloops
	if (to.name === 'PageOnboarding' || to.name === 'PageSignup') {
		// If already on the onboarding page, allow navigation
		return next();
	}

	// If onboarding is not complete, redirect to the onboarding page
	Router.replace({
		name: 'PageOnboarding',
	});
}
